<!-- 转赠明细 -->
<template>
    <div class="jifenDetailPage">
      <!-- header start -->
      <van-nav-bar
        title="转赠明细"
        fixed
        :placeholder="true"
        :z-index="99"
        left-arrow
        @click-left="goBack"
      />
      <!-- header end -->
  
      <div class="tongji-section" v-if="viewData!=null">
        <div class="col">
          <div class="tongji-box">
            <div class="price-box">
              ￥
              <span class="price">{{viewData.InCoin}}</span>
            </div>
            <div class="des">转入</div>
          </div>
        </div>
        <div class="col">
          <div class="tongji-box">
            <div class="price-box">
              ￥
              <span class="price">{{viewData.OutCoin}}</span>
            </div>
            <div class="des">转出</div>
          </div>
        </div>
      </div>
      <div class="selectdate-box" @click="jifenDateShow = true">
        <div class="lable-box">
          <img src="~@/assets/images/clock-icon.png" alt="" class="icon" />
          <span class="title">日期</span>
        </div>
        <div class="input-control">{{ date }}</div>
        <van-icon name="arrow" size="12" color="#999" />
      </div>
      <div class="jifen-box">
        <van-tabs
          v-model="tabActive"
          sticky
          z-index="999"
          offset-top="46"
          :border="false"
          :swipe-threshold="4"
          background="#ffffff"
          color="#f3354f"
          line-height="4px"
        >
          <van-tab title="全部">
            <JifenGiveItem
              :readType="0"
              :beginTime="beginTime"
              :endTime="endTime"
            ></JifenGiveItem>
            <!-- <div class="nohave">已经到底了~</div> -->
          </van-tab>
          <van-tab title="收入">
            <JifenGiveItem
              :readType="1"
              :beginTime="beginTime"
              :endTime="endTime"
            ></JifenGiveItem>
            <!-- <div class="nodata-box">
              <img src="~@/assets/image/NOdata.png" alt="" class="thumb" />
              <div class="tips">哎呀~该页面暂无记录哦</div>
            </div> -->
          </van-tab>
          <van-tab title="支出">
            <JifenGiveItem
              :readType="2"
              :beginTime="beginTime"
              :endTime="endTime"
            ></JifenGiveItem>
            <!-- <div class="nodata-box">
              <img src="~@/assets/image/NOdata.png" alt="" class="thumb" />
              <div class="tips">哎呀~该页面暂无记录哦</div>
            </div> -->
          </van-tab>
        </van-tabs>
      </div>
  
      <!-- 日历 popup start -->
      <van-calendar
        v-model="jifenDateShow"
        type="range"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
      />
      <!-- 日历 popup end -->
    </div>
  </template>
  
  <script>
  import common from "../../../tools/common";
  import JifenGiveItem from "../../../components/JifenGiveItem.vue";
  
  import { Calendar } from "vant";
  export default {
    data() {
      return {
        date: "",
        minDate: new Date(2019, 0, 1),
        maxDate: new Date(),
        currentDate: new Date(),
        jifenDateShow: false,
        tabActive: 0,
        beginTime: "",
        endTime: "",
        viewData:null
      };
    },
    components: {
      [Calendar.name]: Calendar,
      JifenGiveItem
    },
    methods: {
      init(){
        var that=this;
        this.$store.dispatch({type:"TransactionDetailTurnCoinTotal"}).then(res=>{
          common.Response.callNotMsgResponse(res,(data)=>{
            that.viewData=data;
          })
          
        })
  
      },
      goBack() {
        this.$router.go(-1);
      },
      formatDate(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      },
      onConfirm(date) {
        const [start, end] = date;
        this.jifenDateShow = false;
        this.date = `${this.formatDate(start)} ~ ${this.formatDate(end)}`;
        this.beginTime=this.formatDate(start);
        this.endTime=this.formatDate(end);
      }
    },created(){
      this.init();
    }
  };
  </script>
  <style lang="less" scoped>
  .jifenDetailPage {
    padding-bottom: 10px;
  }
  .selectdate-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 12px;
    display: flex;
    align-items: center;
    .lable-box {
      display: flex;
      align-items: center;
      .icon {
        width: 16px;
        height: 16px;
        object-fit: contain;
        margin-right: 10px;
      }
      .title {
        font-size: 16px;
        color: #333;
      }
    }
    .input-control {
      flex: 1;
      overflow: hidden;
      text-align: right;
      font-size: 14px;
      color: #333;
      margin-right: 8px;
    }
  }
  .tongji-section {
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .col {
      width: 49%;
      background: #fff;
      border-radius: 8px;
      padding: 15px 6px;
      height: 100px;
      .tongji-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        .price-box {
          font-size: 12px;
          color: #2b2b2b;
          .price {
            font-size: 22px;
            font-weight: bold;
          }
        }
        .des {
          font-size: 14px;
          color: #7c7c7c;
        }
      }
    }
  }
  .jifen-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 0;
  }
  //转赠item
  .zhuan-item-box {
    margin: 0 10px;
    border-bottom: 1px solid #dedede;
    padding: 14px 0;
    .zhuan-item {
      display: flex;
      align-items: center;
      & > .left-user {
        justify-content: flex-end;
        .bd {
          margin-right: 8px;
          text-align: right;
          overflow: hidden;
          flex: 1;
        }
      }
      & > .right-user {
        .bd {
          margin-left: 8px;
          overflow: hidden;
          flex: 1;
        }
      }
      .u-name {
        font-size: 13px;
        color: #000000;
      }
      .u-date {
        font-size: 12px;
        color: #ababab;
        white-space: nowrap;
      }
      .u-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
      }
      & > .mid-box {
        width: 40px;
        text-align: center;
        margin: 0 10px;
        & > .des {
          font-size: 13px;
          color: #0a0a0a;
        }
        & > .arrow {
          height: 2px;
          background-color: #696969;
          width: 40px;
          display: block;
          margin-top: 2px;
          &.arrow-ru {
            &:after {
              border-color: #696969;
              border-style: solid;
              border-width: 2px 0 0 0;
              -webkit-transform: rotate(35deg);
              -ms-transform: rotate(35deg);
              transform: rotate(35deg);
              margin-top: -3px;
              width: 6px;
              height: 6px;
              display: block;
              float: right;
              content: "";
            }
          }
          &.arrow-chu {
            &:after {
              border-color: #696969;
              border-style: solid;
              border-width: 2px 0 0 0;
              -webkit-transform: rotate(-35deg);
              -ms-transform: rotate(-35deg);
              transform: rotate(-35deg);
              margin-top: -3px;
              width: 6px;
              height: 6px;
              display: block;
              float: left;
              content: "";
            }
          }
        }
        & > .price {
          font-size: 15px;
          color: #ea0000;
        }
      }
    }
    .beizhu {
      text-align: center;
      margin-top: 10px;
      font-size: 12px;
      color: #484848;
    }
  }
  .zhuan-item-box .zhuan-item > .left-user,
  .zhuan-item-box .zhuan-item > .right-user {
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  </style>
  